import { useEffect, useState } from "react"
import { CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, InputLista, Modal } from "../../common"
import { REQUEST_METHOD } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { ServerRequest } from "../../../utils/apiweb"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import {TIPS} from "../../../consts/tips";

import { useForm, useFormErrors, useManagedContext } from "../../hooks"
import { isNull, isValidNumber } from "../../../utils/validator"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const entityInit = {
    id: -1,
    codigo: '',
    nombre: '',
    orden: '',
    idTipoTributo: 0,
    esSupervisor: false,
    email: false,
    direccion: false,
    abogado: false,
    oficialJusticia: false,
}

const TipoControladorModal = ({ item, editMode, onCancel, onConfirm }) => {console.log(item)
    const { setIsLoading } = useManagedContext()

    const [entity, setEntity] = useState(entityInit)
    const [formValues, formHandle, _, formSet] = useForm({
        codigo: '',
        nombre: '',
        orden: '',
        idTipoTributo: 0,
        esSupervisor: false,
        email: false,
        direccion: false,
        abogado: false,
        oficialJusticia: false,
    })

    useEffect(() => {
        setEntity(item)
        formSet({
            codigo: item.codigo,
            nombre: item.nombre,
            orden: item.orden,
            idTipoTributo: item.idTipoTributo,
            esSupervisor: item.esSupervisor,
            email: item.email,
            direccion: item.direccion,
            abogado: item.abogado,
            oficialJusticia: item.oficialJusticia,
        })
    }, [item])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED
        if (formValues.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (isEmptyValue(formValues.orden)) errors.orden = VALIDATION_MESSAGE.REQUIRED

        return errors
    }

    function getFormatErrors() {
        const errors = {}
        if (editMode === 'view') return errors

        if (!isEmptyValue(formValues.orden) && !isValidNumber(formValues.orden, true)) errors.orden = 'Ingresá un número mayor a cero'

        return errors
    }

    function isEmptyValue(valor) {
        return isNull(valor) || valor.toString().length === 0
    }

    const onClickConfirm = () => {
        if (!validate()) return

        setIsLoading(true)

        ServerRequest(
            editMode === 'add' ? REQUEST_METHOD.POST : REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.TIPO_CONTROLADOR,
            editMode === 'modify' ? `/${entity.id}` : '',
            {
                ...entity,
                ...formValues,
                orden: parseInt(formValues.orden) ?? 0,
                idTipoTributo: formValues.idTipoTributo === 0 ? null : formValues.idTipoTributo,
            },
            res => res.json().then(() => {
                setIsLoading(false)
                onConfirm()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            error => {
                onRequestError(error)
                setIsLoading(false)
            },
        )
    }

    const disabled = editMode === 'view'

    return (
        <Modal
            onEscape={onCancel}
            size="xl"
            title="Tipo de controlador"
            tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
            body={(
                <div className='row form-basic'>
                    <div className="col-12">
                        <FormLabel htmlFor="nombre" required>Nombre</FormLabel>
                        <input
                            type="text"
                            name="nombre"
                            className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                            value={formValues.nombre}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('nombre')} />
                    </div>
                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            type="text"
                            name="codigo"
                            maxLength={50}
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={formHandle}
                            disabled={disabled}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={formValues.idTipoTributo}
                            onChange={formHandle}
                            disabled={disabled}
                            lista="TipoTributo"
                            textItemZero="Todos los tributos"
                        />
                        <FormError />
                    </div>
                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="orden" required>Orden</FormLabel>
                        <input
                          name="orden"
						  type="number"
						  placeholder=""
						  className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
						  value={formValues.orden}
						  onChange={formHandle}
						  disabled={disabled}
                        />
                        <FormError message={errorOf('orden')} />
                    </div>
					<div className="col-12">
					    <CheckboxButtonGroup label="Se usa como">
					        <CheckboxButton
					            name="esSupervisor"
					            label="Supervisor/a"
					            checked={formValues.esSupervisor}
					            onChange={formHandle}
					            disabled={disabled}
					        />
					        <CheckboxButton
					            name="email"
					            label="Domicilio electrónico"
					            checked={formValues.email}
					            onChange={formHandle}
					            disabled={disabled}
					        />
					        <CheckboxButton
					            name="direccion"
					            label="Domicilio postal"
					            checked={formValues.direccion}
					            onChange={formHandle}
					            disabled={disabled}
					        />
					        <CheckboxButton
					            name="abogado"
					            label="Abogado/a"
					            checked={formValues.abogado}
					            onChange={formHandle}
					            disabled={disabled}
					        />
					        <CheckboxButton
					            name="oficialJusticia"
					            label="Oficial de justicia"
					            checked={formValues.oficialJusticia}
					            onChange={formHandle}
					            disabled={disabled}
					        />
					    </CheckboxButtonGroup>
					</div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                    {editMode !== 'view' && (
                        <button className="btn action-button" data-dismiss="modal" onClick={onClickConfirm}>Guardar</button>
                    )}
                </div>
                
            )}
        />
    )
}

export default TipoControladorModal
